export const selectAllRoles = ({ RolesSlice: oState }) => oState?.aRoles;
